export default "__VITE_ASSET__CysB$kTo__"